import { Component, ElementRef, inject, Inject, Injectable, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CompleteRegistrationComponent } from './completeRegistration.component';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from '@auth0/auth0-angular';


@Injectable({
  providedIn: 'root'
})

@Component({
  standalone: false,
  selector: 'app-register',
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  constructor(
    private userService: UserService,     
    public auth: AuthService
  ) {} 

  ngOnInit() {
      this.auth.isAuthenticated$.pipe(take(1)).subscribe((isAuthenticated) => {
        if (!isAuthenticated) {
          sessionStorage.setItem('loggedIn', 'true');
          this.auth.loginWithRedirect({
            authorizationParams: {
              screen_hint: "signup",
            }
          });
        }
      });
  }
}
